import { render, staticRenderFns } from "./SamInteractiveLabel.vue?vue&type=template&id=80cc367c&scoped=true&"
import script from "./SamInteractiveLabel.vue?vue&type=script&lang=js&"
export * from "./SamInteractiveLabel.vue?vue&type=script&lang=js&"
import style0 from "./SamInteractiveLabel.vue?vue&type=style&index=0&id=80cc367c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cc367c",
  null
  
)

export default component.exports